import { render, staticRenderFns } from "./disable-tfa.vue?vue&type=template&id=10a9682b&scoped=true"
import script from "./disable-tfa.vue?vue&type=script&lang=js"
export * from "./disable-tfa.vue?vue&type=script&lang=js"
import style0 from "./disable-tfa.vue?vue&type=style&index=0&id=10a9682b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a9682b",
  null
  
)

export default component.exports